window.VGStore.sort = {
	run: function ($self) {
		let $item = $self.closest('[data-sort]'),
			$form = $('#form-catalog-sidebar'),
			$input = $form.find('#catalog-sort-input'),
			key = 'sort-' + $item.data('sort'),
			val = $self.data('sort-type');

		$input.attr('name', key);
		$input.attr('value', val);

		$form.trigger('submit');
	},

	set: function () {
		const urlParams = new URLSearchParams(window.location.search);
		const $listSort = $('#list-sort');
		const $listSortMobile = $('#list-sort-mobile');

		let $lists;

		let sort_param = {},
			variables = ['sort-price', 'sort-name', 'sort-weight'];

		for (const [param, value] of urlParams) {
			if (variables.includes(param)) {
				sort_param.key = param.slice(5);
				sort_param.val = value;
			}
		}

		if ($(window).width() > 992) {
			$lists = $listSort;
		} else {
			$lists = $listSortMobile;
		}

		if ($lists && $lists.length) {
			if ('key' in sort_param) {
				let $sorts = $lists.find('[data-sort]');
				if ($sorts.length) {
					$sorts.each(function () {
						VGStore.sort.reset($(this));
					});

					let $list = $lists.find('[data-sort="' + sort_param.key + '"]');
					if ($list.length) {
						$list.addClass('active');

						if ($(window).width() > 992) {
							let $title_val = $list.find('[data-sort-type="' + sort_param.val + '"]'),
								title = '';

							if ($title_val.length) {
								title = $title_val.text();
								$title_val.addClass('selected');
							}

							$list.find('a[data-bs-toggle]').text(title);
						} else {
							let $title_val = $list.find('[data-title]'),
								$toggle = $list.find('[data-sort-type="' + sort_param.val + '"]'),
								$title = $('#sort-title-mobile'),
								title = '', icon = '';

							if ($title_val.length && $toggle.length) {
								$toggle.addClass('selected');
								title = $title_val.text();
							}

							if (sort_param.val === 'asc') {
								icon = 'fa-arrow-down-wide-short';
								$title.find('i').removeClass('fa-arrow-up-wide-short');
							}
							if (sort_param.val === 'desc') {
								icon = 'fa-arrow-up-wide-short';
								$title.find('i').removeClass('fa-arrow-down-wide-short');
							}

							if($title.length) {
								$title.find('span').text(title);
								$title.find('i').addClass(icon);
							}
						}
					}
				}
			}
		}
	},

	reset: function ($list) {
		$list.removeClass('active');
		$list.find('.selected').removeClass('selected');
		$list.find('a[data-bs-toggle]').text('выбрать');
	}
}

$(document).ready(function () {
	VGStore.sort.set();

	$(document).find('.catalog-sort [data-sort-type], #list-sort-mobile [data-sort-type]').click(function () {
		VGStore.sort.run($(this));

		return false;
	});
});
